<script setup lang="ts">
import {
  ChevronLeftIcon,
  PencilSquareIcon,
  AdjustmentsHorizontalIcon,
} from '@heroicons/vue/24/outline'
import { useI18n } from '@/composable/useI18n'

defineProps<{
  dashboardName: string
  dashboardTypeLabel: string | null
  editMode: boolean
  sidebarOpen: boolean
}>()

const emit = defineEmits<{
  'back-to-catalog': []
  'toggle-edit-mode': []
  'toggle-sidebar': []
}>()

const { t } = useI18n()
</script>

<template>
  <header class="flex shrink-0 items-center justify-between border-b border-stroke bg-white p-6 lg:px-8">
    <div class="flex items-center gap-3">
      <button
        type="button"
        class="flex items-center justify-center p-2 text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900"
        :title="t('custom_dashboards.view.actions.back_to_catalog')"
        @click="emit('back-to-catalog')"
      >
        <ChevronLeftIcon class="h-5 w-5" />
      </button>

      <h1 class="font-satoshi text-title-md2 font-semibold text-black">
        {{ dashboardName }}
      </h1>

      <template v-if="dashboardTypeLabel">
        <div class="h-8 w-px bg-stroke" />
        <span class="bg-gray-2 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-body">
          {{ dashboardTypeLabel }}
        </span>
      </template>
    </div>

    <div class="flex items-center gap-4">
      <button
        type="button"
        :class="[
          'flex items-center gap-2 px-4 py-2 text-sm font-medium transition-colors',
          editMode ? 'bg-primary text-white' : 'border border-stroke bg-white text-black hover:bg-gray-50',
        ]"
        @click="emit('toggle-edit-mode')"
      >
        <PencilSquareIcon class="h-4 w-4" />
        {{
          editMode
            ? t('custom_dashboards.view.header.finish_editing')
            : t('custom_dashboards.view.header.edit_dashboard')
        }}
      </button>

      <button
        type="button"
        class="flex items-center gap-2 border border-stroke bg-white px-4 py-2 text-sm font-medium text-black hover:bg-gray-50"
        @click="emit('toggle-sidebar')"
      >
        <AdjustmentsHorizontalIcon class="h-4 w-4" />
        {{
          sidebarOpen
            ? t('custom_dashboards.view.header.hide_catalog')
            : t('custom_dashboards.view.header.show_catalog')
        }}
      </button>
    </div>
  </header>
</template>
